import React from 'react';
import { ShieldCheck, ExternalLink } from 'lucide-react';

interface FooterProps {
  onOpenLeadModal: (source: string) => void;
}

export const Footer: React.FC<FooterProps> = ({ onOpenLeadModal }) => {
  return (
    <footer className="border-t border-slate-200 bg-slate-50 py-12 md:py-16 text-xs text-slate-600">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
          {/* Col 1: Brand */}
          <div className="space-y-4 md:col-span-2">
            <div className="flex items-center gap-2.5">
              <div className="w-8 h-8 rounded-lg bg-slate-900 border border-slate-700/60 flex items-center justify-center p-0.5 shadow-xs overflow-hidden">
                <img src="/logo-grid-dark.png" alt="ARAYA Vault Logo" className="w-full h-full object-contain" />
              </div>
              <span className="text-lg font-bold text-slate-900 tracking-wider">ARAYA (阿頼耶) Vault</span>
            </div>
            <p className="text-slate-500 max-w-sm leading-relaxed">
              Google Workspaceの障害やハッキングから隔離されたデータ保護基盤。
              絶対に消せない金庫保管と原本証明により、退職者のアカウント料金削減と安心のセキュリティを実現します。
            </p>
            <div className="flex items-center gap-2 text-slate-600 font-mono text-[11px]">
              <ShieldCheck className="w-4 h-4 text-emerald-600" />
              <span>管理者でも削除不可の隔離金庫で安全保護</span>
            </div>
          </div>

          {/* Col 2: Navigation Links */}
          <div>
            <h4 className="text-sm font-bold text-slate-900 mb-4">製品ナビゲーション</h4>
            <ul className="space-y-2.5">
              <li>
                <a href="#problem" className="hover:text-emerald-600 transition-colors">Google Vault の死角</a>
              </li>
              <li>
                <a href="#solution" className="hover:text-emerald-600 transition-colors">4大ソリューション</a>
              </li>
              <li>
                <a href="#architecture" className="hover:text-emerald-600 transition-colors">仕組み・技術</a>
              </li>
              <li>
                <a href="#matrix" className="hover:text-emerald-600 transition-colors">Google Vault対比表</a>
              </li>
              <li>
                <a href="#roi" className="hover:text-emerald-600 transition-colors">退職者コスト削減試算</a>
              </li>
              <li>
                <a href="#faq" className="hover:text-emerald-600 transition-colors">よくあるご質問</a>
              </li>
            </ul>
          </div>

          {/* Col 3: Legal & Support */}
          <div>
            <h4 className="text-sm font-bold text-slate-900 mb-4">お問い合わせ・管理</h4>
            <ul className="space-y-2.5">
              <li>
                <button
                  onClick={() => onOpenLeadModal('footer_poc')}
                  className="hover:text-emerald-600 transition-colors text-left"
                >
                  無料PoC・導入相談
                </button>
              </li>
              <li>
                <button
                  onClick={() => onOpenLeadModal('footer_doc')}
                  className="hover:text-emerald-600 transition-colors text-left"
                >
                  製品資料・技術白書請求
                </button>
              </li>
              <li>
                <a href="/console" className="hover:text-emerald-600 transition-colors flex items-center gap-1 font-medium text-slate-700">
                  社内管理コンソール（@kantsu.com専用） <ExternalLink className="w-3 h-3 text-slate-400" />
                </a>
              </li>
              <li>
                <span className="text-slate-500">ISMS (ISO 27001) 運用体制準拠</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-8 border-t border-slate-200 flex flex-col sm:flex-row items-center justify-between gap-4 text-[11px] text-slate-500">
          <p>© {new Date().getFullYear()} CGL (Chamber of Global Logistics) / Kantsu Co., Ltd. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <span>プライバシーポリシー</span>
            <span>情報セキュリティ基本方針</span>
            <span>特定商取引法に基づく表記</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
